import Notifications from '@/components/framework/NotificationPlugin';

export default {
    install(Vue) {
        Vue.use(Notifications);
    }
};